module.exports = __webpack_public_path__ + "static/media/bcard-202009-7.d3b49ba5.jpg";